module.exports = __webpack_public_path__ + "static/media/logo.5a14e7ea.png";